import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { sleep } from '@ivy/fts/utils';
let BulletinBoard = class BulletinBoard extends Vue {
    constructor() {
        super(...arguments);
        this.number = 0;
    }
    mounted() {
        this.startMove();
    }
    get textContent() {
        return {
            key: this.number,
            val: this.noticeList[this.number].name,
        };
    }
    async startMove() {
        await sleep(3000);
        if (this.number === this.noticeList.length - 1) {
            this.number = 0;
        }
        else {
            this.number += 1;
        }
        this.startMove();
    }
};
tslib_1.__decorate([
    Prop()
], BulletinBoard.prototype, "noticeList", void 0);
BulletinBoard = tslib_1.__decorate([
    Component
], BulletinBoard);
export default BulletinBoard;
